import { render, staticRenderFns } from "./DetalhesContratosOF.vue?vue&type=template&id=e56c25c0"
import script from "./DetalhesContratosOF.vue?vue&type=script&lang=ts"
export * from "./DetalhesContratosOF.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports